<template>
	<div class="chart-wrapper" style="width:100%; height:100%" :id="chartId"></div>
</template>

<script setup>
import loadGoogleCharts from '@/assets/localPlugins/gCharts'

/* Vue */
import { ref, onMounted } from 'vue'

/** props received
@chartId {String}
@graphData {Array}
@colorsArray {Array}
@pieHole {Number}
*/
const props = defineProps({
    chartId: {
        type: String,
        default: () => { return 'myPieChart' }
    },
    graphData: Array,
    colorsArray: {
        type: Array,
        default: () => { return ['#17b694', '#eb9b00'] }
    },
    pieHole: {
        type: Number,
        default: () => { return 0.45 }
    }
})

const chart = ref(null)
const chartsAPI = ref(null)

const initChart = () => {
    // Define the chart to be drawn.
    var data = new window.google.visualization.DataTable()
    data.addColumn('string', 'Element')
    data.addColumn('number', 'Percentage')
    data.addRows(props.graphData)
    // Instantiate and draw the chart.
    const graphOptions = {
        chartArea: { left: 0, top: 0, width: '100%', height: '100%' },
        forceFarme: true,
        pieHole: props.pieHole,
        legend: 'none',
        pieSliceText: 'none',
        tooltip: { trigger: 'none' },
        enableInteractivity: false,
        pieSliceBorderColor: 'transparent',
        colors: props.colorsArray
    }
    chart.value = new chartsAPI.value.visualization.PieChart(document.getElementById(props.chartId))
    chart.value.draw(data, graphOptions)
}

onMounted(() => {
    loadGoogleCharts().then(api => {
        chartsAPI.value = api
        initChart()
    })
})
</script>

<style lang="scss" scoped>
.chart-wrapper {
    :deep(svg) {
        rect {
            fill: var(--secondary-light-4);
        }
    }
}
</style>
